import styled from 'styled-components'

import { HeightClass } from '~/utils/enum/classes'

export const Container = styled.div<{
  heightClass: HeightClass
  disabled?: boolean
}>`
  width: fit-content;

  height: ${({ theme, heightClass }) => theme.starRating[heightClass].height}px;

  ${({ disabled }) => disabled && 'cursor: not-allowed;'}
`

export const Description = styled.h2<{ heightClass: HeightClass }>`
  font-size: ${({ theme, heightClass }) =>
    theme.starRating[heightClass].desFontSize}px;

  font-weight: bold;
  margin: 0;

  margin-bottom: ${({ theme, heightClass }) =>
    theme.starRating[heightClass].vSpacing}px;

  color: ${({ theme }) => theme.colors.blackText};
`

export const Complement = styled.p<{ heightClass: HeightClass }>`
  font-size: ${({ theme, heightClass }) =>
    theme.starRating[heightClass].complementFontSize}px;

  color: ${({ theme }) => theme.colors.blackText};
  margin: 0;

  margin-bottom: ${({ theme, heightClass }) =>
    theme.starRating[heightClass].vSpacing}px;
`
